import { Button, Icon, Modal, Table, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";

import AddDocModal from "../AddOrder/AddDocModal";

const { Column } = Table;
const { confirm } = Modal;

export default class AllDoctors extends Component {
  state = {
    doctorsList: [],
    loading: false,
    dataForModal: {},
    visibleDocModal: false,
    confirmLoading: false,
  };

  componentDidMount = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/doctors.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        console.log(response.data);
        this.setState({
          doctorsList: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        alert(
          `Internet Not working, Please check you connection: ${error.code}`
        );
      });
  };

  showDocModal = () => {
    this.setState({ visibleDocModal: true });
  };

  handleDocCancel = () => {
    this.setState({
      visibleDocModal: false,
      dataForModal: {},
      confirmLoading: false,
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  handleDocCreate = () => {
    const { form } = this.formRef.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      values.partner_id = [];

      values.partner_id.push(values.partner1);

      if (values.partner2 == null) {
        values.partner2 = "";
        values.partner2Locations = [];
      } else {
        values.partner_id.push(values.partner2);
      }

      if (values.partner3 == null) {
        values.partner3 = "";
        values.partner3Locations = [];
      } else {
        values.partner_id.push(values.partner3);
      }

      if (values.partner4 == null) {
        values.partner4 = "";
        values.partner4Locations = [];
      } else {
        values.partner_id.push(values.partner4);
      }

      if (values.partner5 == null) {
        values.partner5 = "";
        values.partner5Locations = [];
      } else {
        values.partner_id.push(values.partner5);
      }

      values.partner_id = [...new Set(values.partner_id)];

      values.partner_location_id = [
        ...new Set([
          ...values.partner1Locations,
          ...values.partner2Locations,
          ...values.partner3Locations,
          ...values.partner4Locations,
          ...values.partner5Locations,
        ]),
      ];

      delete values.partner1;
      delete values.partner2;
      delete values.partner3;
      delete values.partner4;
      delete values.partner5;
      delete values.partner1Locations;
      delete values.partner2Locations;
      delete values.partner3Locations;
      delete values.partner4Locations;
      delete values.partner5Locations;

      axios({
        method: "post",
        url: "/doctors.json",
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: { doctor: values },
      }).then(() => {
        this.setState({
          docConfirmLoad: false,
          confirmLoading: false,
        });
        window.location.reload();
      });

      form.resetFields();
      this.setState({ visibleDocModal: false });
    });
  };

  handleEditDoctor = (record) => {
    this.setState({
      visibleDocModal: true,
      dataForModal: record,
      confirmLoading: true,
    });
  };

  showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure?",
      content:
        "This doctor will be deleted from the database & can not be recovered.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        axios({
          method: "delete",
          url: `/doctors/${id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        })
          .then(() => {
            window.location.reload();
          })
          .catch((error) => console.log(error));
      },
      onCancel: () => {},
    });
  };

  render() {
    const {
      loading,
      doctorsList,
      dataForModal,
      confirmLoading,
      visibleDocModal,
    } = this.state;

    return (
      <div style={{ width: "90%", margin: "auto", marginTop: "5%" }}>
        <h2 style={{ textAlign: "center" }}>Doctors</h2>
        <hr width="100px" />

        <Table
          loading={loading}
          pagination
          bordered
          size="middle"
          dataSource={doctorsList}
          rowKey={(record) => record.id}
        >
          <Column title="ID" dataIndex="id" width={75} align="center" />

          <Column title="Name" dataIndex="name" width={200} align="center" />

          <Column
            title="Contact"
            render={(record) =>
              record.mobile_number == null
                ? "Not Available"
                : record.mobile_number
            }
            width={150}
            align="center"
          />

          <Column
            title="Location"
            align="center"
            render={(record) =>
              record.partner_locations.length === 0 ? null : (
                <span>
                  {record.partner_locations.map((tag) => (
                    <Tag color="blue" key={tag.id}>
                      {tag.name}
                    </Tag>
                  ))}
                </span>
              )
            }
          />

          <Column title="speciality" dataIndex="speciality" width={200} />
          <Column
            fixed="right"
            width={75}
            title="Action"
            render={(record) => (
              <span>
                {/* <Tooltip placement="top" title="Edit Doctor">
                                    <span onClick={() => this.handleEditDoctor(record)} role="button">
                                        <a><Icon type="edit" /></a>
                                    </span>
                                </Tooltip>

                                <Divider type="vertical" /> */}

                <Tooltip placement="top" title="Delete Doctor">
                  <span
                    onClick={() => this.showDeleteConfirm(record.id)}
                    role="button"
                  >
                    <a>
                      <Icon type="delete" style={{ color: "red" }} />
                    </a>
                  </span>
                </Tooltip>
              </span>
            )}
          />
        </Table>

        <div>
          <Button type="primary" onClick={this.showDocModal}>
            Add Doctor
          </Button>
          {visibleDocModal ? (
            <AddDocModal
              wrappedComponentRef={this.saveFormRef}
              data={dataForModal}
              visible={visibleDocModal}
              onCancel={this.handleDocCancel}
              onCreate={this.handleDocCreate}
              confirmLoading={confirmLoading}
            />
          ) : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Doctors/AllDoctors.js